import { Text } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import { CancelConfirmationModalContentViewProps } from './CancelConfirmationModalContentViewProps';

export function CancelConfirmationModalContentVwView({ booking }: CancelConfirmationModalContentViewProps): ReactElement {
  return <Text>Cancel booking {booking.bookingRef}</Text>;
}
